import React, { useEffect } from 'react';
import * as ReactDOM from 'react-dom';

export default function ModalContainer({
  children,
  className = 'root-portal',
  element = 'div'
}) {
  const modalRoot = document.getElementById('portal');
  // eslint-disable-next-line no-unused-vars
  const [container] = React.useState(() => {
    const el = document.createElement(element);
    el.classList.add(className);
    return el;
  });
  useEffect(() => {
    modalRoot.style.width = '100%';
    modalRoot.style.height = '100%';
    modalRoot.style.position = 'fixed';
    modalRoot.style.display = 'flex';
    modalRoot.style.justifyContent = 'center';
    modalRoot.style.alignItems = 'center';
    modalRoot.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    modalRoot.style.zIndex = '21';

    return () => {
      modalRoot.style.width = '0';
      modalRoot.style.height = '0';
      modalRoot.style.backgroundColor = 'transparent';
      modalRoot.style.zIndex = '0';
    };
  }, []);
  return ReactDOM.createPortal(children, modalRoot);
}
